export default "__VITE_ASSET__B4MFP3av__"